import { createContext } from 'react';

interface SidebarContextProps {
  showOnMobile: boolean;
  toggleShowOnMobile: () => void;
}

const SidebarContext = createContext<SidebarContextProps>({
  showOnMobile: false,
  toggleShowOnMobile: () => {},
});

export default SidebarContext;
